const maindiv = {
  position: "absolute",
  background: "rgba(0,0,0,0.9)",
  height: "2850px",
  width: "100%",
  zIndex: "9999",
};

const NetworkSwitch = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const networkHandler = async () => {
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0x38" }],
      });
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div
        className={`${
          open ? "block" : "hidden"
        } min-w-screen h-screen animated fadeIn faster pt-80 inset-0 z-50 outline-none focus:outline-none`}
        id="modal-id"
        style={{ ...maindiv }}
      >
        <div className="absolute bg-black opacity-80 inset-0 z-0" />
        <div className="w-full  max-w-lg p-5 relative mx-auto my-auto rounded-3xl shadow-lg bg-btn-2  text-white-50 ">
          {/*content*/}
          <div className="">
            {/*body*/}
            <div className="text-center p-5 flex-auto justify-center">
              <h2 className="text-xl font-bold py-4 ">Error</h2>
              <p className="text-sm text-gray-500 px-8">
                You are on wrong network please switch your network.
              </p>
            </div>
            {/*footer*/}
            <div className="p-3  mt-2 text-center space-x-4 md:block">
              <button
                onClick={handleClose}
                className="mb-2 md:mb-0 bg-white px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-gray-600 rounded-full hover:shadow-lg hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={networkHandler}
                className="mb-2 md:mb-0 bg-red-500 border border-red-500 px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white rounded-full hover:shadow-lg hover:bg-red-600"
              >
                Switch Network
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default NetworkSwitch;
